// ** React Imports
import React, { Suspense, useContext } from "react";
// ** Context Imports
import { shallowEqual, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { AbilityContext } from "@metronic/_context/Can";

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const ability = useContext(AbilityContext);
  const { user } = useSelector((state) => ({ user: state.auth.user.user }), shallowEqual);

  if (route) {
    let action = null;
    let resource = null;
    let abilities = null;
    let restrictedRoute = false;

    if (route.meta) {
      action = route.meta.action;
      resource = route.meta.resource;
      abilities = route.meta.abilities;
      restrictedRoute = route.meta.restricted;
    }

    if (!user) {
      return <Navigate to="/login" />;
    }

    if (user && restrictedRoute) {
      return <Navigate to="/" />;
    }

    if (abilities) {
      let isAllowed = false
      for (const ab of abilities) {
        const allow = ability.can(ab.action, ab.resource);
        if (allow) {
          isAllowed = true;

        }
      }

      if (!isAllowed) {
        console.error('private route - not-authorized', abilities)
        return <Navigate to='/misc/not-authorized' replace />
      }
    } else if (action && resource && user && !ability.can(action || 'read', resource)) {
      console.error('private route - else not-authorized, action, resource', action, resource)
      return <Navigate to='/misc/not-authorized' replace />
    }
  }

  return (
    <Suspense >
      {children}
    </Suspense>
  );
};

export default PrivateRoute;
